import React, { useState } from "react";
import { Box } from "@mui/material";
import Header from "../../components/common/Header";
import Sidebar from "../../components/common/Sidebar";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleDesktopCollapse = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const currentDrawerWidth = sidebarCollapsed ? 72 : 280;

  return (
    <Box sx={{ display: "flex", backgroundColor: "#fafafa", minHeight: "100vh" }}>
      <Header 
        drawerWidth={280}
        onMobileOpen={handleDrawerToggle} 
        onDesktopCollapse={handleDesktopCollapse} 
      />
      <Sidebar
        drawerWidth={currentDrawerWidth}
        mobileOpen={mobileOpen}
        onMobileClose={handleDrawerToggle}
        collapsed={sidebarCollapsed}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 1.5, sm: 2, md: 3 },
          width: { xs: "100%", sm: `calc(100% - ${currentDrawerWidth}px)` },
          maxWidth: "100%",
          minWidth: 0,
          overflowX: "hidden",
          mt: "64px",
          minHeight: "calc(100vh - 64px)",
          backgroundColor: "#fafafa",
          transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default Layout;
